<template>
    <div
        class="pt-select-dropdown"
        :class="[{ 'is-multiple': isMultiple }, popperClass]"
        :style="{ minWidth: minWidth }"
    >
        <slot></slot>
    </div>
</template>

<script lang="ts">
export default {
    name: 'PtSelectMenu',
};
</script>

<script setup lang="ts">
import { computed, onMounted, onBeforeUnmount, inject, ref } from 'vue';
import { addResizeListener, removeResizeListener } from '../../../utils/resize-event';
import type { ResizableElement } from '../../../utils/resize-event';
import { selectKey } from './token';

const select = inject(selectKey);
// computed
const popperClass = computed(() => select?.props.popperClass);
const isMultiple = computed(() => select?.props.multiple);
const minWidth = ref('');

function updateMinWidth() {
    minWidth.value = select?.selectWrapper?.getBoundingClientRect().width + 'px';
}

onMounted(() => {
    // TODO: updatePopper
    // popper.value.update()
    addResizeListener(select?.selectWrapper as ResizableElement, updateMinWidth);
});

onBeforeUnmount(() => {
    removeResizeListener(select?.selectWrapper as ResizableElement, updateMinWidth);
});
</script>

<style lang="scss" src="../style/select-dropdown.scss"></style>
